// extracted by mini-css-extract-plugin
export default {"button":"G773a73","buttonFullWidth":"G2dd03f","buttonChild":"Gba6d5d"};